<section class="flex flex-col items-center gap-12 text-center" id="faq">
  <app-section-header [title]="'Frequently asked questions'">
    <p #description>
      Do you have questions about Native Builds? We have answered the most
      frequently asked questions for you here - if your question is not
      included, don't hesitate to contact us by
      <a [href]="'mailto:' + emailSupport" target="_blank">Email</a> or via
      <a [href]="discordUrl" target="_blank">Discord</a>.
    </p>
  </app-section-header>
  <app-faq-accordion [items]="items" class="w-full lg:w-[1024px]" />
</section>
